export default __webpack_public_path__ + "static/media/help12.67b375d6.png";